<template>
  <div class="project-list-wrap">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span class="title">项目</span>
        <div class="search">
          <el-input
            v-model="searchProjectText"
            size="small"
            placeholder="搜索项目名称"
            clearable
            prefix-icon="el-icon-search"
          ></el-input>
        </div>
        <tabs
          :tab-list="projectTabs"
          :default-active="activeProjectType"
          @click="changeProjectTab"
          class="tabs"
        ></tabs>
      </div>
      <div v-loading="loading">
        <ul v-if="loading || (filterProjects && filterProjects.length > 0)" class="project-list">
          <draggable
            group="projects"
            :disabled="activeProjectType !== 'star'"
            v-model="favoriteProjectIds"
            :animation="100"
            @update="changeProjectFavoriteList"
          >
            <li
              v-for="project in filterProjects"
              :key="project.id"
              @click="clickProject(project)"
              @mouseenter="changeProjectMouseIn(project.id, true)"
              @mouseleave="changeProjectMouseIn(project.id, false)"
            >
              <div class="project-item">
                <div class="project-icon" :style="{ background: '#1989FA' }">
                  <svg-icon
                    :icon-class="project.icon ? 'project_' + project.icon : 'project_folder'"
                  ></svg-icon>
                </div>
                <span class="project-name" v-tip>{{ project.name }}</span>
                <svg-icon
                  style="margin-right: 6px"
                  v-if="mouseProjectIn[project.id]"
                  :icon-class="project.favorite ? 'star_add-favorite' : 'star_not-add-favorite'"
                  @click.native.stop="setProjectFavorite(project.id)"
                ></svg-icon>
                <el-progress
                  :percentage="project.completeRate | getPercentage"
                  class="progress"
                  color="#1989FA"
                ></el-progress>
              </div>
              <div class="divider">
                <el-divider></el-divider>
              </div>
            </li>
            <li v-if="projectPermission && activeProjectType === 'all'" class="add-wrapper">
              <div class="add-project" @click="goManageProject">
                <i class="el-icon-plus"></i>
              </div>
              <span class="project-name">新建项目</span>
            </li>
          </draggable>
        </ul>
        <div v-else class="filter-empty">
          <svg-icon icon-class="noProject"></svg-icon>
          <div class="no-available">
            暂无项目
            <template
              v-if="
                activeProjectType === 'all' &&
                  projects &&
                  projects.length === 0 &&
                  projectPermission
              "
            >
              <span>,</span>
              <span class="create" @click="goManageProject">
                立即添加+
              </span>
            </template>
          </div>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import draggable from "vuedraggable"
import { getFavoriteList, setFavoriteList } from "@/api/userCenter/app"
import { getProjectGroupList } from "@/api/user"
import { getProjectList } from "@/api/project/project"
import { checkCompanyPermission } from "@/utils/checkPermission"
import Tabs from "@/components/UIComponents/Tab"
export default {
  name: "project-list",
  components: { draggable, Tabs },
  props: { userInfo: Object },
  filters: {
    getPercentage(val) {
      return Math.floor(val * 100)
    }
  },
  data() {
    return {
      searchProjectText: "",
      projectList: [],
      favoriteProjectIds: [],
      activeProjectType: "all",
      groupProjectList: [],
      mouseProject: {
        projectId: "",
        param: ""
      },
      projectPermission: false,
      loading: false
    }
  },
  computed: {
    wholeProjects() {
      return this.projectList.map(project => {
        project.favorite = this.favoriteProjectIds.includes(project.id)
        return project
      })
    },
    allProjects() {
      return this.wholeProjects.filter(project => !project.suspended)
    },
    suspendedProjects() {
      return this.wholeProjects.filter(project => project.suspended)
    },
    projectMap() {
      let result = {}
      this.wholeProjects.forEach(item => {
        result[item.id] = item
      })
      return result
    },
    favoriteProjects() {
      let result = []
      this.favoriteProjectIds.forEach(projectId => {
        if (
          this._.keys(this.projectMap).includes(projectId) &&
          !this.projectMap[projectId].suspended
        ) {
          result.push(this.projectMap[projectId])
        }
      })
      return result
    },
    groupProjects() {
      let result = {}
      this.groupProjectList.forEach(t => {
        let list = []
        t.projectIdList.forEach(projectId => {
          if (
            this._.keys(this.projectMap).includes(projectId) &&
            !this.projectMap[projectId].suspended
          ) {
            let project = this.projectMap[projectId]
            project.favorite = this.favoriteProjectIds.includes(projectId)
            list.push(project)
          }
        })
        result[t.id] = list
      })
      return result
    },
    groupProjectTabs() {
      let result = []
      this.groupProjectList.forEach(t => {
        if (this.groupProjects[t.id].length > 0) {
          result.push({ label: t.name, value: t.id })
        }
      })
      return result
    },
    projectTabs() {
      return (this.favoriteProjects.length > 0 ? [{ label: "星标项目", value: "star" }] : [])
        .concat([{ label: "全部项目", value: "all" }])
        .concat(this.suspendedProjects.length > 0 ? { label: "已归档", value: "suspended" } : [])
        .concat(this.groupProjectTabs)
    },
    projects() {
      switch (this.activeProjectType) {
        case "all":
          return this.allProjects
        case "suspended":
          return this.suspendedProjects
        case "star":
          return this.favoriteProjects || []
        default:
          return this.groupProjects[this.activeProjectType]
      }
    },
    filterProjects() {
      return this.projects.filter(project => project.name.includes(this.searchProjectText))
    },
    mouseProjectIn() {
      let result = {}
      this.filterProjects.forEach(project => {
        if (this.mouseProject.projectId === project.id) {
          result[project.id] = this.mouseProject.param
        } else {
          result[project.id] = false
        }
      })
      return result
    }
  },
  created() {
    this.refresh()
  },
  methods: {
    async refresh() {
      this.loading = true
      this.favoriteProjectIds = (await getFavoriteList("project")) || []
      this.projectList = await getProjectList({ withCount: true })
      await getProjectGroupList().then(res => {
        this.groupProjectList = res
      })
      this.projectPermission = checkCompanyPermission({
        companyId: this.userInfo.companyId,
        pri: "项目列表"
      })
      this.activeProjectType = this.projectTabs[0].value
      this.loading = false
    },
    clickProject(project) {
      this.$router.push({ name: "project-task-list", params: { projectId: project.id } })
    },
    changeProjectTab(key) {
      this.activeProjectType = key
    },
    goManageProject() {
      const { href } = this.$router.resolve({
        name: "company-manage-project",
        query: {
          dialogName: "add"
        }
      })
      window.open(href, "_blank")
    },
    setProjectFavorite(projectId) {
      if (this.favoriteProjectIds.includes(projectId)) {
        let index = this.favoriteProjectIds.indexOf(projectId)
        this.favoriteProjectIds.splice(index, 1)
        if (this.favoriteProjectIds.length === 0) {
          this.activeProjectType = "all"
        }
      } else {
        this.favoriteProjectIds.push(projectId)
      }
      setFavoriteList(this.favoriteProjectIds, "project")
    },
    changeProjectFavoriteList() {
      setFavoriteList(this.favoriteProjectIds, "project")
    },
    changeProjectMouseIn(projectId, param) {
      this.mouseProject.projectId = projectId
      this.mouseProject.param = param
    }
  }
}
</script>

<style lang="scss" scoped>
.project-list-wrap {
  min-height: 339px;
  .el-card {
    min-height: 338px;
    border-radius: 6px;
  }
  .clearfix {
    border-bottom: 1px solid #ebeef5;
  }
  .title {
    font-size: 20px;
    margin-left: 12px;
  }
  .search {
    float: right;
    display: flex;
  }
  .tabs {
    margin-top: 10px;
  }
  .filter-empty {
    text-align: center;
    min-height: 200px;
    .svg-icon,
    i {
      font-size: 160px;
      color: #fff;
    }
  }
  ::v-deep {
    .el-card__header {
      padding: 18px 20px 0 20px;
      border-bottom: none;
    }
    .el-card__body {
      padding: 20px 10px;
    }
    .el-icon-star-off:before {
      font-size: 15px;
    }
  }
  .project-list {
    font-size: $font-size-main;
    min-height: 200px;
    .add-wrapper {
      display: flex;
      align-items: center;
      .add-project {
        @include flex-center;
        width: 50px;
        height: 50px;
        border-radius: 14px;
        background: #f5f7fa;
        margin: 14px 22px;
        color: #c0c4cc;
        font-size: 20px;
        cursor: pointer;
      }
    }
    .divider {
      margin: 0 15px;
      .el-divider--horizontal {
        margin: 0;
        background-color: #f5f7fa;
      }
    }
    .project-item {
      display: flex;
      align-items: center;
      padding: 12px 8px 13px;
      cursor: pointer;
      &:hover {
        background-color: $color-bg-select;
        border-radius: 6px;
      }
      &:only-child {
        border-bottom: none;
      }
    }
    .project-icon {
      @include flex-center;
      margin-right: 20px;
      margin-left: 14px;
      width: 50px;
      height: 50px;
      color: #fff;
      font-size: 35px;
      border-radius: 14px;
    }
    .project-name {
      flex: 1;
      margin-right: 6px;
      color: #535c65;
    }
    .progress {
      width: 175px;
      margin-left: auto;
      ::v-deep {
        .el-progress-bar {
          width: 120px;
          box-sizing: content-box;
        }
        .el-progress__text {
          float: right;
          margin-right: 5px;
        }
      }
    }
  }
  .no-available {
    color: #c0c4cc;
    font-size: 14px;
    .create {
      color: #1989fa;
    }
  }
}
</style>
